import React from 'react';
import Carousel from '@components/common/Carousel';
import cn from 'classnames';
import styles from './tiles.module.scss';
import { flowType } from '@utility/userInfo';

const Tiles = (props) => {
  const {
    data, carouselData, onClick,
    isSuccessCallServer
  } = props;
  const isKiosk = flowType() === 'kiosk';
  const isTableTop = flowType() === 'tableTop';
  const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  return (
    <div className={cn('col-12 p-0 m-0 h-100 overflowY', { 'row overflowX overflowYHidden': isKiosk })}>
      {isTableTop && themeProperties?.tableTopHeroImageUrl && (
        <div className="mb-2">
          <img
            src={themeProperties.tableTopHeroImageUrl}
            alt=""
            className="img-fluid mx-auto d-block"
          />
        </div>
      )}
      {carouselData && carouselData.map((e) => {
        return (
          <div key={e?.id} className={cn('mx-0 mb-2 od-text-primary text-primary', { 'col-12 px-0': isKiosk }, { 'row card': isTableTop })}>
            <div className={isKiosk ? 'h-90' : 'h-100'}>
              <Carousel imageUrls={e.imageUrls && e.imageUrls.length > 0 ? e.imageUrls : [e.imageUrl]} style={{ imageSize: 'img-fluid mx-auto d-block w-100' }} />
            </div>
            {isTableTop && (
              <div className={cn('fs-14', 'col-12 px-2 py-1 h-10 fw-600 text-capitalize')}>
                {e.displayName}
              </div>
            )}
          </div>
        );
      })}
      {data && data.length > 0 && data.map((e) => {
        return (
          <div
            key={e.id}
            className={cn('mx-0 mb-2 od-text-primary text-primary', { 'col-12 px-0': isKiosk }, { 'card ': !isKiosk }, { 'row ': isTableTop }, styles.cardMinHeight)}
            role="presentation"
            onClick={() => { return ((e.link === 'CallServer') && isSuccessCallServer) ? '' : onClick([4].includes(e.tileType) ? e.tileType : e.link); }}
          >
            {(e.imageUrl) && (
              <div className={cn('col-12 p-0', isKiosk ? 'h-100' : 'h-75')}>
                <img
                  src={e.imageUrl}
                  alt="img"
                  style={{ objectFit: 'cover' }}
                  className={cn('img-fluid mx-auto d-block w-100')}
                />
              </div>
            )}
            {isTableTop && (
              <>
                <div className={cn('col-12 px-2 py-1 fw-600', e.imageUrl ? 'h-10' : 'h-25', ((e.link === 'CallServer') && isSuccessCallServer) ? 'od-text-secondary text-secondary' : 'od-text-primary text-primary text-capitalize fs-14')}>
                  {((e.link === 'CallServer') && isSuccessCallServer) ? 'Assitance has been requested' : (e.displayName)}
                </div>
                {e.description && (
                <div className={cn('col-12 px-2 fs-14', e.imageUrl ? 'h-15' : 'h-75')}>
                  {e.description}
                </div>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Tiles;
